var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFormikContext } from "formik";
import React, { useState } from "react";
import { usePreview } from "../../generator-api";
import { errorMessage } from "../../generator-error-messages";
export var DownloadButton = function (_a) {
    var setGeneratorStep = _a.setGeneratorStep, setToken = _a.setToken, token = _a.token;
    var _b = useFormikContext(), values = _b.values, resetForm = _b.resetForm;
    var _c = usePreview(values, token), loading = _c.loading, url = _c.url, message = _c.message;
    var _d = __read(useState(false), 2), downloaded = _d[0], setDownloaded = _d[1];
    var format = useFormikContext().values.format;
    // if (message == 'RECAPTCHA_VERIFICATION_FAILED'){
    //   setToken(null);
    // }
    return (React.createElement(React.Fragment, null, downloaded ? (React.createElement(React.Fragment, null,
        React.createElement("div", null, "Soubor byl \u00FAsp\u011B\u0161n\u011B ulo\u017Een"),
        React.createElement("div", { className: "download-pdf__buttons" },
            React.createElement("button", { className: "download-pdf__button", type: 'reset', onClick: function () { resetForm; } }, "Vytvo\u0159it nov\u00FD podklad"),
            React.createElement("button", { className: "download-pdf__button", type: 'button', onClick: function () { setGeneratorStep(2); } }, "Upravit tento podklad")))) : (loading ? (React.createElement(React.Fragment, null,
        React.createElement("svg", { className: "loader__loader", viewBox: "0 0 120 120", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { className: "loader__circle", cx: "60", cy: "60", r: "40" }),
            React.createElement("g", null,
                React.createElement("circle", { className: "loader__dot loader__dot--first", cx: "45", cy: "70", r: "4" }),
                React.createElement("circle", { className: "loader__dot loader__dot--second", cx: "60", cy: "70", r: "4" }),
                React.createElement("circle", { className: "loader__dot loader__dot--third", cx: "75", cy: "70", r: "4" }))),
        React.createElement("div", null, "Prob\u00EDh\u00E1 generov\u00E1n\u00ED"))) : (message == undefined ? (React.createElement("button", { type: 'button', onClick: function () { setDownloaded(true); } }, format === "poster_electronic_single" ? (React.createElement("a", { href: "data:image/jpef;base64," + url, className: "download-pdf__button", download: "document.jpeg" }, "St\u00E1hnout JPG soubor")) : (React.createElement("a", { href: "data:application/pdf;base64," + url, className: "download-pdf__button", download: "document.pdf" }, "St\u00E1hnout soubor v PDF")))) : (React.createElement("div", null, errorMessage(message)))))));
};
